// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Types
import { MarketType, SolutionType } from '../../types';
type Props = {
  values: Object,
  handleInputChange: Function,
  clearFilter: Function,
  markets: Array<MarketType>,
  solutions: Array<SolutionType>
};

const ProductsFilters = ({
  values,
  handleInputChange,
  clearFilter,
  markets,
  solutions
}: Props) => (
  <div className="section section--sm u--padding-top-0">
    <div className="product-filters">
      <div className="product-filters__heading">Filter Products:</div>
      <div className="product-filters__fields">
        <div className="product-filters__field form__field">
          <div
            className={classnames('form__select', {
              'form__select--has-clear': values.market
            })}
          >
            <select
              name="market"
              value={values.market}
              onChange={handleInputChange}
            >
              <option value="">Markets&hellip;</option>
              {markets.map(market => (
                <optgroup key={market.id} label={market.title}>
                  {market.submarkets.map(submarket => (
                    <option key={submarket.id} value={submarket.id}>
                      {submarket.title}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
            {values.market && (
              <button
                type="button"
                className="form__select__clear"
                onClick={() => clearFilter('market')}
              />
            )}
          </div>
        </div>
        <div className="product-filters__field form__field">
          <div
            className={classnames('form__select', {
              'form__select--has-clear': values.solution
            })}
          >
            <select
              name="solution"
              value={values.solution}
              onChange={handleInputChange}
            >
              <option value="">Solutions&hellip;</option>
              {solutions.map(solution => (
                <option key={solution.id} value={solution.id}>
                  {solution.title}
                </option>
              ))}
            </select>
            {values.solution && (
              <button
                type="button"
                className="form__select__clear"
                onClick={() => clearFilter('solution')}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProductsFilters;
